import React from 'react';

function LoadingSkeleton({ width = '100%', height = '20px', count = 1, style = {} }) {
  const items = Array.from({ length: count }, (_, i) => i);

  return (
    <>
      {items.map((i) => (
        <div
          key={i}
          className="skeleton"
          style={{
            width,
            height,
            marginBottom: count > 1 ? '10px' : 0,
            ...style,
          }}
        />
      ))}
    </>
  );
}

export default LoadingSkeleton;
